import anchorme from 'anchorme';

const parseTextUrlToAnchor = (input: string) => anchorme({
  input,
  options: {
    attributes: {
      target: '_blank',
      class: 'twilio-message-anchor',
    },
  },
});

export default parseTextUrlToAnchor;
